<template>
  <div class="row tab event-tab pt-5 pb-5">
    <div class="col-12 event p-0">
      <div class="row container row-event">
        <div class="col-sm-6 event-right">
          <img src="@/assets/images/business/emtyaz.jpg" alt />
        </div>
        <div class="col-sm-6 event-left">
          <div class="enevt-left-text">
            <h5>عنوان خبر</h5>
            <h6>تاریخ : 1399/05/05</h6>
            <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی گیرد.</p>
          </div>
          <a href class="enevt-left-more d-flex">
            <i class="icon-plus"></i>
            <p>بیشتر</p>
          </a>
        </div>
      </div>
    </div>

    <div class="col-12 event p-0">
      <div class="row container row-event">
        <div class="col-sm-6 event-left">
          <div class="enevt-left-text">
            <h5>عنوان خبر</h5>
            <h6>تاریخ : 1399/05/05</h6>
            <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی گیرد.</p>
          </div>
          <a href class="enevt-left-more d-flex">
            <i class="icon-plus"></i>
            <p>بیشتر</p>
          </a>
        </div>

        <div class="col-sm-6 event-right">
          <img src="@/assets/images/business/emtyaz.jpg" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Posts",
};
</script>